import { useQuery } from "@tanstack/react-query";
import { Spinner } from "app/components";
import { authService } from "app/services";
import { createContext, useContext } from "react";

const ProfileContext = createContext();

export function ProfileProvider({ children }) {
  const profileQuery = useQuery({
    queryKey: ["get:profile"],
    queryFn: authService.getProfile,
  });

  function hasAccessTo(accessId) {
    const acceso = profileQuery.data.accesos.includes(accessId);

    return !!acceso;
  }

  if (!!profileQuery.isLoading) {
    return <Spinner label="Cargando el perfil de usuario..." />;
  }

  if (!!profileQuery.isError) {
    return "Error";
  }

  return (
    <ProfileContext.Provider
      value={{ profile: profileQuery.data, hasAccessTo }}
    >
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfileContext() {
  const profileContext = useContext(ProfileContext);

  if (!profileContext) {
    throw new Error(
      "useProfileContext should be used inside the ProfileProvider."
    );
  }

  return profileContext;
}
